import { render, staticRenderFns } from "./MFooterWiz.vue?vue&type=template&id=85d48426&"
import script from "./MFooterWiz.ts?vue&type=script&lang=ts&"
export * from "./MFooterWiz.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports